import _ from 'lodash'
import { connect } from 'react-redux'

import { getCurrentApp } from 'e-submission/apps/selectors'

function EncComponent(Component) {
  return connect(
    (state) => state,
    (dispatch) => ({ dispatch }),
    (state, { dispatch }, { mergeState, ...props }) => {
      const app = getCurrentApp(state)
      const value = _.get(app, props.id)
      let componentProps = {}
      if (_.isFunction(mergeState)) {
        componentProps = mergeState(state, app, {
          dispatch,
          ...props,
        })
      }

      return {
        ...props,
        value,
        ...componentProps,
      }
    },
    {
      areStatePropsEqual: (a, b) => a === b,
    }
  )(function EncComponent(props) {
    const { setValue, component } = props
    const isComponentDebounced = ['TextInput', 'NumberInput', 'DateDropdownInput', 'DateInput'].some(
      (v) => v === component
    )
    const _setValue = isComponentDebounced && typeof setValue === 'function' ? _.debounce(setValue, 300) : setValue

    return <Component {...props} setValue={_setValue} />
  })
}

export default EncComponent
